<template>
  <div class="recharge">
    <Row class="rechargeTip">
      <Col class="desc" span="12">
        <h3 class="title">
          <i></i>
          <span>{{$t('label.w135')}}</span>
        </h3>
        <ul class="detail">
          <li v-html="$t('other.w101')"></li>
          <li>{{$t('other.w102')}}</li>
          <li>{{$t('other.w103')}}</li>
        </ul>
      </Col>
      <Col span="12" class="bg">
        <div class="img"></div>
      </Col>
    </Row>
    <div class="sw">
      <RechargeSwitch :type.sync="type" />
    </div>
    <Row v-show="type == 'feeaccount'" class="feeaccount">
      <Col span="12" class="flex-e">
        <div class="bankcard">
          <p>{{$t('other.w104')}}</p>
          <p>{{$t('other.w105')}}</p>
          <P>6217 8820 0000 0885 654</P>
          <P>{{$t('other.w106')}}</P>
        </div>
      </Col>
      <Col span="12" class="flex-s">
        <div class="copycard">
          <p>
            <span>{{$t('other.w104')}}</span>
            <span id="feename">{{$t('other.w105')}}</span>
            <span
              @click="copy"
              data-clipboard-target="#feename"
              :data-clipboard-text="$t('other.w105')"
              class="btn"
            ></span>
          </p>
          <p>
            <span>{{$t('other.w107')}}</span>
            <span id="feebank">{{$t('other.w106')}}</span>
            <span
              @click="copy"
              data-clipboard-target="#feebank"
              :data-clipboard-text="$t('other.w106')"
              class="btn"
            ></span>
          </p>
          <p>
            <span v-html="$t('other.w108')"></span>
            <span id="feenum">6217 8820 0000 0885 654</span>
            <span
              @click="copy"
              data-clipboard-target="#feenum"
              data-clipboard-text="6217882000000885654"
              class="btn"
            ></span>
          </p>
        </div>
      </Col>
    </Row>
    <!-- <Row v-show="type == 'feeaccount'" class="feeaccount">
      <Col span="12" class="flex-e">
        <div class="bankcard bankcard1">
          <p>{{$t('other.w104')}}</p>
          <p>{{$t('other.w1051')}}</p>
          <P>6230 5800 0016 2975 127</P>
          <P>{{$t('other.w136')}}</P>
        </div>
      </Col>
      <Col span="12" class="flex-s">
        <div class="copycard">
          <p>
            <span>{{$t('other.w104')}}</span>
            <span id="feename">{{$t('other.w1051')}}</span>
            <span
              @click="copy"
              data-clipboard-target="#feename"
              :data-clipboard-text="$t('other.w1051')"
              class="btn"
            ></span>
          </p>
          <p>
            <span>{{$t('other.w107')}}</span>
            <span id="feebank">{{$t('other.w136')}}</span>
            <span
              @click="copy"
              data-clipboard-target="#feebank"
              :data-clipboard-text="$t('other.w136')"
              class="btn"
            ></span>
          </p>
          <p>
            <span v-html="$t('other.w108')"></span>
            <span id="feenum">6230 5800 0016 2975 127</span>
            <span
              @click="copy"
              data-clipboard-target="#feenum"
              data-clipboard-text="6230580000162975127"
              class="btn"
            ></span>
          </p>
        </div>
      </Col>
    </Row> -->
    <Row v-show="type == 'management'" class="feeaccount">
      <Col span="12" class="flex-e">
        <div class="bankcard management">
          <p>{{$t('other.w104')}}</p>
          <p>{{$t('other.w109')}}</p>
          <P>3900 0188 0001 1003 0</P>
          <P>{{$t('other.w110')}}</P>
        </div>
      </Col>
      <Col span="12" class="flex-s">
        <div class="copycard">
          <p>
            <span>{{$t('other.w104')}}</span>
            <span id="company">{{$t('other.w109')}}</span>
            <span
              @click="copy"
              data-clipboard-target="#company"
              :data-clipboard-text="$t('other.w109')"
              class="btn"
            ></span>
          </p>
          <p>
            <span>{{$t('other.w107')}}</span>
            <span id="bank">{{$t('other.w110')}}</span>
            <span
              @click="copy"
              data-clipboard-target="#bank"
              :data-clipboard-text="$t('other.w110')"
              class="btn"
            ></span>
          </p>
          <p>
            <span id="num" v-html="$t('other.w108')"></span>
            <span>3900 0188 0001 1003 0</span>
            <span
              @click="copy"
              data-clipboard-target="#num"
              data-clipboard-text="39000188000110030"
              class="btn"
            ></span>
          </p>
        </div>
      </Col>
    </Row>
  </div>
</template>
<script>
import RechargeSwitch from "./rechargeSwitch";
import Clipboard from "clipboard";
export default {
  components: { RechargeSwitch },
  data() {
    return {
      type: "feeaccount"
    };
  },
  mounted() {},
  methods: {
    copy() {
      let clipboard = new Clipboard(".btn");
      //因为var是全局变量，let和const是局部
      clipboard.on("success", e => {
        this.$Message.success(this.$t("msg.m127"));
        clipboard.destroy(); //使用destroy可以清楚缓存
      });
      clipboard.on("error", e => {
        this.$Message.error(this.$t("msg.m128"));
        clipboard.destroy();
      });
    }
  }
};
</script>

<style lang="less" scoped>
.recharge {
  .rechargeTip {
    display: flex;
    padding-left: 100px;
    background: url("../../assets/assetcenter/public_quotes.png") no-repeat;
    background-size: 90px 74px;
    background-position: 40px 80px;
    .title {
      font-weight: 500;
      color: rgba(94, 143, 252, 1);
      font-size: 14px;
      margin: 40px 0 30px -20px;
      span {
        margin-left: 5px;
      }
      i {
        display: inline-block;
        background: url("../../assets/assetcenter/public_hint.png") no-repeat;
        width: 14px;
        height: 13px;
        background-size: cover;
      }
    }
    .desc {
      .detail {
        li {
          width: 439px;
          font-size: 14px;
          color: rgba(51, 51, 51, 1);
          margin-bottom: 20px;
          letter-spacing: 1;
          list-style: decimal;
        }
      }
    }
    .bg {
      padding-left: 150px;
      .img {
        width: 407px;
        height: 283px;
        background: url("../../assets/assetcenter/recharge_bg.png") no-repeat;
        background-size: cover;
      }
    }
  }
  .sw {
    margin: 64px 0 50px 0;
  }
  .feeaccount {
    .flex-e {
      display: flex;
      justify-content: flex-end;
      .bankcard {
        width: 331px;
        height: 186px;
        padding: 17px 0 0 48px;
        color: #fff;
        background: url("../../assets/assetcenter/recharge_bank.png") no-repeat;
        background-size: cover;
        p:nth-child(1) {
          opacity: 0.5;
        }
        p:nth-child(2) {
          font-size: 16px;
          margin-bottom: 22px;
        }
        p:nth-child(3) {
          font-size: 20px;
          font-family: DIN-Medium;
          font-weight: 500;
          color: rgba(255, 255, 255, 1);
          margin-bottom: 20px;
        }
        p:nth-child(4) {
          opacity: 0.5;
        }
      }
      .bankcard1,
      .management {
        background: url("../../assets/assetcenter/recharge_bank2.png") no-repeat;
        background-size: cover;
      }
    }
    .flex-s {
      display: flex;
      justify-content: flex-start;
      .copycard {
        height: 186px;
        padding: 28px 0 0 30px;
        p {
          margin-bottom: 20px;
          font-size: 14px;
          color: #7b7b7c;
          span {
            display: inline-block;
          }
          span:first-child {
            text-align: justify;
            margin-right: 30px;
            width: 45px;
          }
          span:nth-child(2) {
            color: #232325;
            margin-right: 50px;
            min-width: 170px;
          }
          span:last-child {
            background: url("../../assets/assetcenter/public_copy.png")
              no-repeat;
            width: 14px;
            height: 14px;
            background-size: cover;
            cursor: pointer;
          }
        }
      }
    }
  }
}
</style>
